export default {
  path: "/fotos",
  name: "Fotos",
  component: () => import("../pages/index.vue")
};
